import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { Tipos } from 'src/app/auth/register/interfaces/tipos';

@Component({
  selector: 'app-editar-perfil',
  standalone: true,
  imports: [DialogModule, ConfirmDialogModule, FormsModule, ReactiveFormsModule, CommonModule, InputTextModule],
  templateUrl: './editar-perfil.component.html',
  styleUrl: './editar-perfil.component.scss'
})
export class EditarPerfilComponent implements OnInit {
    @Input() usuarioDialog: boolean=false;

    @Output() onUsuarioDialogChange = new EventEmitter<{openDialog:boolean|any; estadoAccion:boolean|any; submitted:boolean|any}>();
    @Output() closeAndSaveDialogUser = new EventEmitter<{loading:boolean; case:string;}>();
    @Output() onSave = new EventEmitter<{ nombres: string; apellidos: string }>();
    @Output() onClose = new EventEmitter<void>();
    loading: boolean=false;
    formEditar: FormGroup;
    @Input() idTipoPersona!: number | undefined;
    closeDialogUser() {
        this.usuarioDialog=false;
        this.closeAndSaveDialogUser.emit({loading:this.loading, case:"close"});
        this.formEditar.reset();
    }
    constructor(private fb: FormBuilder){
        this.formEditar = this.nuevoFormEditar();
    }
    ngOnInit(): void {
        
    }

    nuevoFormEditar() {
    return this.fb.group({
        nombres: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(500)]),
        apellidos: new FormControl<string | null>(null, [Validators.maxLength(500)])
        });
    }

    isNit() {
        return this.formEditar.get('tipoDocumento')?.value?.idTipoDocumento == 2
    }

    onConfirmSubmit() {
        if(this.formEditar.invalid) {
            this.formEditar.markAllAsTouched();
        return;
        }
        const payload = this.formEditar.value;
        this.onSave.emit(payload);
        this.onClose.emit();
    }
}
